import { useUser } from '~/features/auth/api/useUser'

export const useUserWallet = () => {
    const {
        data: { wallets },
    } = useUser()

    return { wallets }
}
